export default __webpack_public_path__ + "static/060-1b1a3d104b0bae61bfe2bce1339b0090.jpg";